import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import StayHydrated from 'assets/images/awaiting-approval/stay-hydrated.png';
import PrioritiseSleep from 'assets/images/awaiting-approval/prioritise-sleep.png';
import BalancedDiet from 'assets/images/awaiting-approval/balanced-diet.png';
import StayActive from 'assets/images/awaiting-approval/stay-active.png';

export default function useHealthRecommendations() {
  const { t } = useTranslation();

  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const recommendations = [
    {
      title: t('stay_hydrated'),
      desc: t('stay_hydrated_info'),
      img: StayHydrated,
    },
    {
      title: t('prioritise_sleep'),
      desc: t('prioritise_sleep_info'),
      img: PrioritiseSleep,
    },
    {
      title: t('eat_balanced_diet'),
      desc: t('eat_balanced_diet_info'),
      img: BalancedDiet,
    },
    {
      title: t('stay_active'),
      desc: t('stay_active_info'),
      img: StayActive,
    },
  ] as const;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === recommendations.length - 1 ? 0 : prev + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return {
    title: recommendations[currentIndex].title,
    desc: recommendations[currentIndex].desc,
    img: recommendations[currentIndex].img,
  };
}
